import { Handle, Position, useReactFlow } from '@xyflow/react'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { v4 as uuidv4 } from 'uuid';
import { Box, Typography, useTheme } from '@mui/material';
import CheckHandleNodeEvent from '../../../../utils/CheckHandleNodeEvent';
import { CustomTooltip } from '../../../../components/TooltipCustomStyle';
import TooltipStatusTitle from '../../../../components/TooltipStatusTitle';
import ErrorIcon from '@mui/icons-material/Error';

const init = {
    data: {
        general_properties: {
            label: '',
            descriptoin: '',
            subjectConstraints: [],
        },
        error_text: ["General properties incomplete. Please complete them."],
        restfulapi_parent_node: 'node_id',
    },
};

function RouterNode(props) {
    const {
        data,
        selected
    } = props;

    const theme = useTheme();

    return (
        <div
            className={`min-w-[160px] h-6 bg-blue-600 ${selected ? 'border border-blue-600' : 'border border-gray-300'} rounded-sm px-2 justify-center items-center flex flex-col relative cursor-pointer`}
        >
            <div className='flex justify-center items-center'>
                <Typography
                    variant="subtitle2"
                    color='white'
                    fontSize={{
                        lg: 12,
                        md: 10,
                        sm: 10,
                        xs: 10
                    }}
                    sx={{
                        cursor: 'pointer',
                    }}
                >
                    /{data?.general_properties?.label}
                </Typography>
            </div>
            <button
                // onClick={addChildNode}
                className="w-[18px] h-[18px] rounded-full bg-white hover:bg-gray-300 
                flex items-center justify-center 
                absolute right-[-10px] top-1/2 -translate-y-1/2 border border-gray-300"
            >
                <MoreHorizIcon className="text-gray-700" sx={{ fontSize: 15 }} />
            </button>
            {data?.error_text.length > 0 &&
                <div
                    style={{
                        position: 'absolute',
                        top: '-15px',
                        right: '5%',
                        transform: 'translate(-50%, 0)',
                        zIndex: 1000,
                        textAlign: 'center',
                    }}
                >
                    <CustomTooltip title={<TooltipStatusTitle headerTitle="Error" listDetails={data?.error_text} />} arrow placement="top" tooltipcolorstyle={theme.palette.error.main}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                background: '#fff',
                                width: 15,
                                height: 15,
                                marginTop: '5px'
                            }}
                        >
                            <ErrorIcon sx={{
                                color: theme.palette.error.main,
                                fontSize: 18,
                            }} />
                        </Box>
                    </CustomTooltip>
                </div>
            }
            {/* <Handle
                position={Position.Left}
                type="target"
            /> */}
            <Handle
                id="left-target"
                type="target"
                position={Position.Left}
                style={CheckHandleNodeEvent(data, selected)}
            />
            <Handle
                position={Position.Right}
                type="source"
                style={{
                    background: 'transparent',
                    border: 'none',
                    width: '1px',
                    height: '1px',
                    pointerEvents: 'none'
                }}
            />
        </div>
    )
}

export default RouterNode